import { State } from '../state';

export const RegistrationSelectors = {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    registration: (state: State) => state.Registration,
};
